// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TextMessageType;
(function (TextMessageType) {
    TextMessageType[TextMessageType["CHAT_MESSGE"] = 1] = "CHAT_MESSGE";
    TextMessageType[TextMessageType["LINK_CHANGE"] = 2] = "LINK_CHANGE";
    TextMessageType[TextMessageType["STATUS_CHANGE"] = 3] = "STATUS_CHANGE";
    TextMessageType[TextMessageType["SIGNAL_MESSGE"] = 4] = "SIGNAL_MESSGE";
    TextMessageType[TextMessageType["FILE_MESSGE"] = 5] = "FILE_MESSGE";
    TextMessageType[TextMessageType["GROUP_MESSGE"] = 6] = "GROUP_MESSGE";
    TextMessageType[TextMessageType["RANK_MESSGE"] = 7] = "RANK_MESSGE";
    TextMessageType[TextMessageType["BROKER_MESSAGE_URGENT_TYPE"] = 8] = "BROKER_MESSAGE_URGENT_TYPE";
    TextMessageType[TextMessageType["BROKER_MESSAGE_WELCOME_TYPE"] = 9] = "BROKER_MESSAGE_WELCOME_TYPE";
    TextMessageType[TextMessageType["BROKER_MESSAGE_PERIODIC_TYPE"] = 10] = "BROKER_MESSAGE_PERIODIC_TYPE";
    TextMessageType[TextMessageType["BROKER_MESSAGE_DAILY_WELCOME_TYPE"] = 11] = "BROKER_MESSAGE_DAILY_WELCOME_TYPE";
    TextMessageType[TextMessageType["BROKER_MESSAGE_NOTIFICATION_TYPE"] = 12] = "BROKER_MESSAGE_NOTIFICATION_TYPE";
})(TextMessageType || (TextMessageType = {}));
